import { Resources } from 'constants/resources';

import { hydraSchemaAnalyzer } from '@api-platform/admin';
import {
  ProvidersShowWhiteIpAddressesForm,
  WhiteIpAddressesFormValues,
} from 'pages/Providers/ProvidersShow/ProvidersShowWhiteIpAddresses/components/ProvidersShowWhiteIpAddressesForm';
import {
  Form,
  HttpError,
  Identifier,
  RecordContextProvider,
  useNotify,
  useUpdate,
} from 'react-admin';
import { Button, SaveButton } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { ProviderWhiteIpAddress } from 'types/embedded/provider';
import { getServerErrorMessage } from 'utils/getServerErrorMessage';

type Props = {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  record?: ProviderWhiteIpAddress;
  provider?: Identifier;
};

export const ProvidersShowWhiteIpAddressesEditDialog: React.FC<Props> = ({
  open,
  onClose,
  record,
  onDelete,
}) => {
  const [update] = useUpdate();
  const notify = useNotify();

  const onSubmit = async (formValues: WhiteIpAddressesFormValues) => {
    try {
      await update(
        Resources.ProviderWhiteIpAddresses,
        {
          id: record?.id,
          data: {
            ...formValues,
            provider: record?.provider,
            comment: formValues.comment ?? '',
          },
        },
        { returnPromise: true },
      );
      notify('Белый IP адрес успешно отредактирован!', {
        type: 'success',
      });
      onClose();
    } catch (error) {
      const submissionErrors = hydraSchemaAnalyzer().getSubmissionErrors(error as HttpError);
      if (submissionErrors) {
        return submissionErrors;
      }
      notify(`Ошибка: ${await getServerErrorMessage(error)}`, { type: 'error' });
    }
  };

  return (
    <Dialog fullWidth onClose={onClose} open={open}>
      <RecordContextProvider value={record}>
        <Form onSubmit={onSubmit as any}>
          <CardHeader
            appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
            title="Редактирование белого IP"
            titleSize="smallBold"
          />
          <ProvidersShowWhiteIpAddressesForm />
          <CardActionsButtons
            leftActionsSlot={
              <Button
                color="error"
                key="delete-button"
                label="Удалить"
                onClick={onDelete}
                variant="outlined"
              />
            }
            rightActionsSlot={[
              <Button key="cancel" label="Отменить" onClick={onClose} variant="outlined" />,
              <SaveButton key="submit" label="Сохранить" />,
            ]}
          />
        </Form>
      </RecordContextProvider>
    </Dialog>
  );
};
